__turbopack_context__.v({
  "ant-select-selection-search": "SearchSelect-module__LSamDW__ant-select-selection-search",
  "searchSelect": "SearchSelect-module__LSamDW__searchSelect",
  "searchSelectPopup": "SearchSelect-module__LSamDW__searchSelectPopup",
});
